function Research2022() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-16">2022</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-16">Nov</div>
                    <div className="w-full">
                        <p><a href="https://park.itc.u-tokyo.ac.jp/MSF/topology/TuesdaySeminar/22_2_e.html" target='_blank'>“An obstruction problem associated with finite path-integral.”</a></p>
                        <p>Tuesday Seminar on Topology, the university of Tokyo</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Research2022;